<template>
  <v-card
    class="ra-0"
    :height="height"
    v-bind="$attrs"
    v-on="$listeners"
    :color="is_organisasi ? color : 'white'"
    flat
    @click="$emit('pilih')"
  >
    <!-- Card Tipe Pilihan Organisasi -->
    <v-card-text v-if="is_organisasi" class="pa-0 row" fill-height>
      <v-container fill-height fluid class="align-center">
        <v-col cols="12" class="text-center py-3">
          <div class="logo">
            <v-avatar
              v-if="$vuetify.breakpoint.mdAndUp"
              size="50"
            >
              <img :src="img || 'img/organisasi-default.png'" alt />
            </v-avatar>
            <v-avatar
              v-if="$vuetify.breakpoint.smAndDown"
              size="30">
              <img :src="img || 'img/organisasi-default.png'" alt />
            </v-avatar>
          </div>

          <div
            v-if="$vuetify.breakpoint.mdAndUp"
            class="pt-2 black--text"
            style="overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;"
          >
            {{ title }}
          </div>

          <div
            v-if="$vuetify.breakpoint.smAndDown"
            class="text-center"
            style="overflow: hidden;
                  display: -webkit-box;
                  font-size: 13px;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;"
          >
            {{ title }}
          </div>
        </v-col>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-row v-if="icon">
        <div class="logo" style="position: absolute;right: 20px;top: 20px;">
          <v-avatar
            :color="iconAvatarColor"
            size="65"
          >
            <v-icon :size="40" :color="iconColor">{{ icon }}</v-icon>
          </v-avatar>
        </div>
      </v-row>
      <!-- Card Tipe Record Data -->
      <v-row v-else>
        <div class="logo" style="position: absolute;left: 10px;top: 5px;">
          <v-avatar size="62">
            <img :src="img || 'img/organisasi-default.png'" alt />
          </v-avatar>
        </div>
      </v-row>
      <v-row justify-center class="pa-0" v-if="icon">
        <v-col cols="12" class="detail">
          <div
            class="value mt-1 display-1 font-weight-bold black--text"
          >
            {{ value }}
          </div>
          <div class="subheader font-weight-bold primary--text">
            {{ title }}
          </div>
          <div class="caption grey--text">
                  data 1 jam yang lalu ...
          </div>
        </v-col>
      </v-row>
      <v-row justify-center class="pa-0" v-else>
        <v-col cols="12" class="text-center white--text">
          <div class="header font-weight-bold text-right">{{ title }}</div>
        </v-col>
      </v-row>
    </v-card-text>
    <template v-if="false">
      <v-divider class="mt-3 mx-3"></v-divider>
      <v-card-actions class="px-3" v-if="desc">
        <v-icon v-if="iconDesc" small class="mr-2 theme--light">
          {{ iconDesc }}
        </v-icon>
        <span class="grey--text caption font-weight-light">{{ desc }}</span>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "BlockCard",
  inheritAttrs: false,
  props: {
    // Pilihan format tipe card organisasi atau tampilan card data global
    is_organisasi: {
      type: Boolean,
      default: false
    },
    //judul
    title: {
      type: String,
      default: "Title"
    },
    //nilai yang harus diisi jika memilih tampilan card data
    value: {
      type: [Number, String],
      default: 0
    },
    //deskripsi
    desc: {
      type: String,
      default: ""
    },
    //warna card
    color: {
      type: String,
      default: "primary"
    },
    // icon card yang digunakan jika memilih model card data
    icon: {
      type: String,
      default: null
    },
    // warna icon
    iconColor: {
      type: String,
      default: 'teal accent-3'
    },
    // warna icon avatar
    iconAvatarColor: {
      type: String,
      default: 'teal lighten-5'
    },
    //logo yang digunakan jika memilih tipe card organisasi
    logo: {
      type: String,
      default: null
    },
    // informasi tambahan
    iconDesc: {
      type: String,
      default: ""
    },
    // progress bar untuk pencapaian
    progressBar: {
      type: String,
      default: "on"
    },
    // nilai progress bar
    progressValue: {
      type: Number,
      default: 10
    },
    // tinggi card
    height: {
      type: Number,
      default: 105
    }
  },

  data() {
    return {
      img: null
    }
  },

  created() {
    this.checkImage(this.logo || '')
  },

  methods: {
    checkImage(imgSrc) {
      let img = new Image()

      img.onload = () => {
        this.img = imgSrc
      }
      img.src = imgSrc
    },
  },

  watch: {
    logo: 'checkImage'
  }
};
</script>

<style></style>
